module.exports = "/_next/static/images/c86f3fc198dbd7eba904cc08cae1faa0-join-us-md-3x.png";